export const iconFontAwesomeMedicalHealthSyringe = (
	<i className="fa-solid fa-syringe"></i>
);
